import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Tabs } from 'tea-component';
import MetricsTableForDownload from './MetricsTableForDownload';
import { pageMaps } from '../constants';
import moment from 'moment';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { accountsTipsText } from '@/pages/opinion/components/BubbleCommon/copywritingKey/accounts';
import OverviewTab from './OverviewTab';
import { NavigatorsType } from '@/pages/opinion/types/accounts';
import { connect, useIntl } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import '@/pages/opinion/assets/scss/pages/accounts/Overview.scss';
import {
  buriedPagePoint,
  useInitBuriedPointInfo,
} from '@op/operationLog/buriedPoint';
import byChannelDownload from '@op/operationLog/pages/byChannelDownload';
import byChannelOverview from '@op/operationLog/pages/byChannelOverview';
import byAccountOverview from '@op/operationLog/pages/byAccountOverview';
import byAccountDownload from '@op/operationLog/pages/byAccountDownload';
import { useNavigatorScroll } from '@/pages/opinion/components/Navigator';
import { getFilterValueDefaultConfig } from '@/pages/opinion/services';
import ContentBody from '@/pages/opinion/components/ContentBody';
import {
  commonAccountsPageOfficialAccounts,
  serversSplitText,
} from '@op/components/FilterCommon/utils/monitorUtil';
import { DBO_TM } from '@op/utils/format';
import { sortArrayAuxiliaryFunc } from '@op/utils';
import { channelSortList } from '@op/constants/channel';
const buriedPointMap: any = {
  'channel-Overview': byChannelOverview,
  'channel-Download': byChannelDownload,
  'account-Overview': byAccountOverview,
  'account-Download': byAccountDownload,
};
const { Content } = Layout;

function AccountsPage({
  gameInfo,
  type,
  pageName,
}: {
  type?: any;
  gameInfo?: any;
  pageName: 'By_Account' | 'By_Channel';
}) {
  const { formatMessage } = useIntl();
  const tabs = [
    { id: 'Overview', label: formatMessage({ id: 'Overview' }) },
    {
      id: 'Download',
      label: formatMessage({ id: 'Metrics Table for Download' }),
    },
  ];
  const [tab, setTab] = useState('Overview');
  const { loading, filter, changeFilter, filterOptions } = useFilterDataHook({
    pageName,
    gameInfo,
  });

  const [channelList, setChannelList] = useState<Array<string>>([]);
  const {
    defaultNavigator,
    pageTitle,
    navigators: baseNavigators,
  } = useMemo(() => {
    return pageMaps[type];
  }, [type]);

  useInitBuriedPointInfo({
    buriedPoint: buriedPointMap[`${type}-${tab}`],
    triggerPagePoint: false,
  });

  useEffect(() => {
    buriedPagePoint();
  }, [type, tab]);
  const [navigators, setNavigators] = useState<NavigatorsType>([]);
  const { selectNavigator, setSelectNavigator, handleScroll, scrollBody } =
    useNavigatorScroll({
      allKeys: [{ name: defaultNavigator }, ...navigators].map(
        (item) => item.name,
      ),
      defaultValue: defaultNavigator,
      debounceTime: 10,
    });
  const requestServerDefaultFilter = async () => {
    try {
      if (gameInfo?.edition_unified_id === 'u10000000066') {
        const data = await getFilterValueDefaultConfig({
          ...gameInfo,
          page: `/opinion/Accounts/${
            type === 'channel' ? 'ByChannel' : 'ByAccount'
          }`,
        });
        // 请求接口，获取默认官号
        const value = JSON.parse(data?.value || '{}');
        // 这里后期需要修改
        const defaultAccount = (
          value.social_media_by_channel_accounts || []
        ).map((item: any) =>
          item?.replace('#_to_#', serversSplitText).toLocaleLowerCase(),
        );

        return defaultAccount.filter(Boolean) || [];
      }
    } catch (error) {}
  };

  return (
    <Content
      className="dbo-page dbo-accounts"
      id="echartAppendInfoId"
      ref={scrollBody}
      onScrollCapture={handleScroll}
    >
      <ContentBody
        pageName={pageTitle}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: pageTitle })}
            className="dbo-header contentHead-normal"
            subtitle={
              <div className="dbo-header-subtitle ">
                {formatMessage({ id: 'Data Update: Not real-time data' })}
                <BubbleCommon tipsMap={accountsTipsText}></BubbleCommon>
              </div>
            }
          >
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={tabs}
                animated={false}
                activeId={tab}
                onActive={(tab) => setTab(tab.id)}
              />
            </div>
          </Content.Header>
        }
      >
        <FilterFixed
          filter={filterOptions}
          operateShowOptions={['save', 'history', 'more']}
          defaultConfig={{
            date: { dateTypeList: ['date'] },
            channel: { channelKey: 'social' },
            monitor: { onlyAccount: true, returnAllValue: true },
          }}
          dealwithFinallyCondData={(cond: any) => {
            const monitory = cond?.monitor_by_account_category?.monitory;
            if (!monitory) return cond;
            cond.monitor_by_account_category.monitory =
              commonAccountsPageOfficialAccounts(monitory);

            return cond;
          }}
          historyConfig={{ fixFilter: { date_type: 'daily' } }}
          finallyDealwithDefaultValue={async (value) => {
            let { date_type, social_media_by_account, ...otherProps } = value;

            if (
              social_media_by_account ||
              social_media_by_account.length === 0
            ) {
              const newSocialMedia = await requestServerDefaultFilter();
              if (newSocialMedia)
                social_media_by_account = newSocialMedia.map((item: string) =>
                  item.toLocaleLowerCase(),
                );
            }
            return {
              ...otherProps,
              date_type: 'daily',
              social_media_by_account,
            };
          }}
          defaultValue={DBO_TM.utcFilterRangeDay(6, 0)}
          confirm={(value: any) => {
            changeFilter({ ...value, ...gameInfo });
          }}
          backCondOriginData={(value) => {
            const list = value?.channel?.social || [];
            list.sort(sortArrayAuxiliaryFunc(channelSortList));
            setChannelList(list);
          }}
          // defaultAccount={defaultAccount}
        ></FilterFixed>

        <CardLoading loading={loading}>
          {tab === 'Overview' ? (
            <OverviewTab
              setNavigators={setNavigators}
              navigators={navigators}
              type={type}
              channelList={channelList}
              filter={filter}
              baseNavigators={baseNavigators}
              gameInfo={gameInfo}
              defaultNavigator={defaultNavigator}
              setSelectNavigator={setSelectNavigator}
              selectNavigator={selectNavigator}
              scrollBody={scrollBody}
            ></OverviewTab>
          ) : (
            // 第二个tab  Metrics Table For Download
            <MetricsTableForDownload
              keepParams={filter}
              type={type}
            ></MetricsTableForDownload>
          )}
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(AccountsPage);
